module.exports = __webpack_public_path__ + "static/media/Anthony_S@3x.37673785.jpg";